export const environment = {
  production: true,

  // Environment variable to know in which environment we are
  env: 'PRODUCTION',

  //Browser needs localhost or 127.0.0.1
  //Check always that calling and receiver have the same, one or the other
  domain_api: 'https://prod.back.mopcorner.com/api',
  domain_app: 'https://app.mopcorner.com',
  domain: 'https://app.mopcorner.com', //Deeplinks work only with root domain

  domain_api_emu: 'https://prod.back.mopcorner.com/api',
  domain_app_emu: 'https://app.mopcorner.com',

  //Stripe - Payment platform
  stripe_publishable_key: 'pk_live_51LpVLzLxWwmFpaC0lEJuBlHooGSCvQOUZ1DWt31m2AJFjGTe5ZrDx7TPnRtOCvKBjhxWlHbWfXSAElHTdqljiyjg00i9VgOQZ8',

  //OneSignal - Notifications platform
  onesignal_key: '9ebfd1bc-ffd3-4e57-8b0d-6825e4f477b9',

  //Legal terms
  privacy_policy: 'https://mopcorner.com/legal-terms/privacy-policy.html',
  legal_notice: 'https://mopcorner.com/legal-terms/legal-notice.html',
  cookies_policy: 'https://mopcorner.com/legal-terms/cookies-policy.html',

  server_trust: true,

  notifications_refresh: 60000, //1 minutes
  notifications_do_refresh: true,
  notifications_counter: 0,
  messages_counter: 0
};
